// frontend/src/pages/dashboard/subscription/UpgradeModal.js
import React, { useEffect } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import axios from 'axios'

export default function UpgradeModal ({ show, onHide, priceId }) {
  useEffect(() => {
    if (show && priceId) createCheckout()
  }, [show, priceId])

  async function createCheckout () {
    try {
      const { data } = await axios.post(
        '/api/billing/stripe/checkout',
        { priceId },
        {
          withCredentials: true,
          baseURL: ''       // don’t prepend another /api
        }
      )

      // backend returns a full Checkout URL – just navigate to it
      window.location.href = typeof data === 'string' ? data : data.url
    } catch (err) {
      console.error(err)
      onHide()
    }
  }

  return (
    <Modal show={show} onHide={onHide} backdrop='static' centered>
      <Modal.Body className='text-center'>
        <Spinner animation='border' />
        <p className='mt-3 mb-0'>Redirecting to Stripe…</p>
      </Modal.Body>
    </Modal>
  )
}
